import { authUserIdSelector, authUserSelector } from 'selectors/authSelectors';
import { store } from 'MooTeam';
import Immutable from 'immutable';
import { getTaskByIdWithSummary } from 'selectors/ui/viewSelectors';

class ChecklistOwn {
  execute = (executeParams) => {
    if (!executeParams.model) {
      return false;
    }
    const currentUserId = authUserIdSelector(store.getState());
    const task = executeParams.model;

    if (task.get('userId') || task.get('coPerformerId') || task.get('creatorId')) {
      return [task.get('userId'), task.get('coPerformerId'), task.get('creatorId')].includes(currentUserId);
    }

    return false;
  };
}

// Checks if user trying to update his own profile
class UserUpdateOwn {
  execute = (executeParams) => {
    if (!executeParams.model || !executeParams.model.get('userId')) {
      return false;
    }
    const currentUserId = authUserIdSelector(store.getState());

    return executeParams.model.get('userId') === currentUserId;
  };
}

// Checks if user trying to update his own article
class ArticleUpdateOwn {
  execute = (executeParams) => {
    if (!executeParams.model || !executeParams.model.get('userId')) {
      return false;
    }
    const currentUserId = authUserIdSelector(store.getState());

    return executeParams.model.get('userId') === currentUserId;
  };
}

// Checks if user trying to update his own event
class EventUpdateOwn {
  execute = (executeParams) => {
    if (!executeParams.model || !executeParams.model.get('userId')) {
      return false;
    }
    const currentUserId = authUserIdSelector(store.getState());

    return executeParams.model.get('userId') === currentUserId;
  };
}

class InProjectLeader {
  execute = (executeParams) => {
    if (!executeParams.model) {
      return false;
    }
    const user = authUserSelector(store.getState());
    const team = executeParams.model.get('team');

    return team
      ? team.find((memberTeam) => {
          const isAuthUser = memberTeam?.get('userId') === user.get('userId');
          return isAuthUser && ['leader', 'responsible', 'manager'].includes(memberTeam.get('type'));
        })
      : false;
  };
}

class InProjectTeam {
  execute = (executeParams) => {
    if (!executeParams.model) {
      return false;
    }
    const user = authUserSelector(store.getState());
    const team = executeParams.model.get('team');

    return team ? team.find((value) => value.get('userId') === user.get('userId')) : false;
  };
}

class clientUserViewOwn {
  execute = (executeParams) => {
    if (!executeParams.model) {
      return false;
    }
    const user = authUserSelector(store.getState());

    return !!executeParams.model.get('clientId') === user.get('clientId');
  };
}

class ClientUserUpdateOwn {
  execute = (executeParams) => {
    if (!executeParams.model) {
      return false;
    }
    const user = authUserSelector(store.getState());

    return executeParams.model.get('userId') === user.get('userId');
  };
}

class TaskSubscribe {
  execute = (executeParams) => {
    if (!executeParams.model) {
      return false;
    }
    const user = authUserSelector(store.getState());
    const project = executeParams.model.get('project');
    const team = project?.get('team');

    const isManager = team?.find(
      (memberTeam) => memberTeam.get('type') === 'manager' && memberTeam.get('userId') === user.get('userId'),
    );

    if (isManager) {
      return true;
    }

    let privacy = true;
    let currentUserId = user.get('userId');

    if (executeParams.model.get('privacyUsers') && executeParams.model.get('privacyUsers').size !== 0) {
      privacy = executeParams.model.get('privacyUsers').some((item) => {
        if (Immutable.isMap(item)) {
          return item.get('userId') === currentUserId || item.getIn(['user', 'userId']) === currentUserId;
        }
        return item === currentUserId;
      });
    }

    if (project && privacy) {
      const team = project.get('team');
      return team ? !!team.find((memberTeam) => memberTeam.get('userId') === user.get('userId')) : false;
    }

    return false;
  };
}

class TaskResponsible {
  execute = (executeParams) => {
    if (!executeParams.model) {
      return false;
    }
    const user = authUserSelector(store.getState());

    return executeParams.model.get('userId') === user.get('userId');
  };
}

class TaskUpdateOwn {
  execute = (executeParams) => {
    if (!executeParams.model) {
      return false;
    }

    const user = authUserSelector(store.getState());
    return executeParams.model.get('creatorId') === user.get('userId');
  };
}

class TaskUpdateLeader {
  execute = (executeParams) => {
    if (!executeParams.model) {
      return false;
    }

    const user = authUserSelector(store.getState());
    const team = executeParams.model.get('project') ? executeParams.model.getIn(['project', 'team']) : null;
    const types = ['responsible', 'leader', 'manager'];

    return team
      ? team.find(
          (memberTeam) =>
            typeof memberTeam === 'object' &&
            types.includes(memberTeam.get('type')) &&
            memberTeam.get('status') === 'active' &&
            memberTeam.get('userId') === user.get('userId'),
        )
      : false;
  };
}

class IsCommentCreator {
  execute = (executeParams) => {
    if (!executeParams.model) {
      return false;
    }
    const user = authUserSelector(store.getState());
    return executeParams.model.get('createdBy') === user.get('userId');
  };
}

class TaskViewOwn {
  execute = (executeParams) => {
    if (!executeParams.model) {
      return false;
    }
    const user = authUserSelector(store.getState());

    if (executeParams.model.get('project') && executeParams.model.getIn(['project', 'team'])) {
      if (executeParams.model.get('projectId')) {
        return true;
      }

      const team = executeParams.model.getIn(['project', 'team']);
      return team ? team.find((value) => value.get('userId') === user.get('userId')) : false;
    }

    return false;
  };
}

class CommentUpdateInTask {
  execute = (executeParams) => {
    if (!executeParams.model) {
      return false;
    }

    const user = authUserSelector(store.getState());
    const task = getTaskByIdWithSummary(store.getState(), { taskId: executeParams.model.get('entityId') });

    if (task && task.get('project')) {
      const team = task.getIn(['project', 'team']);
      return team ? team.find((memberTeam) => memberTeam.get('userId') === user.get('userId')) : false;
    }

    return false;
  };
}

class ProjectViewOwn {
  execute = (executeParams) => {
    if (!executeParams.model) {
      return false;
    }

    const user = authUserSelector(store.getState());

    if (user.get('userType') === 'client' && executeParams.model.get('status') === 'archived') {
      return false;
    }

    const team = executeParams.model.get('team');
    return team ? team.find((memberTeam) => memberTeam?.get('userId') === user.get('userId')) : false;
  };
}

class TaskTimeOwn {
  execute = (executeParams) => {
    if (!executeParams.model) {
      return false;
    }

    const user = authUserSelector(store.getState());

    return executeParams.model.userId === user.get('userId');
  };
}

class TimeCreateOwn {
  execute = (executeParams) => {
    if (!executeParams.model) {
      return false;
    }

    const userId = authUserIdSelector(store.getState());

    return executeParams.model.userId === userId;
  };
}

class TimeViewOwn {
  execute = (executeParams) => {
    if (!executeParams.model) {
      return false;
    }

    const user = authUserSelector(store.getState());

    if (user.get('userType') === 'client') {
      const project = executeParams.model.get('project');
      const team = project ? project.get('team') : null;

      return team ? team.find((map) => map.get('userId') === user.get('userId')) : false;
    }

    return true;
  };
}

class ToolAccessCreateOwn {
  execute = () => {
    const user = authUserSelector(store.getState());
    return user.get('userType') !== 'client';
  };
}

class ToolAccessViewOwn {
  execute = (executeParams) => {
    const credential = executeParams.model;

    if (!credential) {
      return false;
    }

    if (!credential.get('projectId')) {
      return true;
    }

    const user = authUserSelector(store.getState());

    if (user.get('userType') === 'client' && credential.getIn(['project', 'canClientViewAccesses'])) {
      return true;
    }

    if (user.get('userType') !== 'client' && credential.getIn(['project', 'canTeamViewAccesses'])) {
      return true;
    }

    const team = credential.getIn(['project', 'team']);
    const types = ['leader', 'responsible', 'manager'];

    return team
      ? team.find((memberTeam) => {
          return memberTeam.get('userId') === user.get('userId') && types.includes(memberTeam.get('type'));
        })
      : false;
  };
}

class ToolAccessIndexAvailable {
  execute = (executeParams) => {
    const user = authUserSelector(store.getState());
    if (!executeParams.model) {
      if (user.get('userType') === 'client') {
        return false;
      }
      return true;
    }

    const project = executeParams.model;

    if (user.get('userType') === 'client' && project.get('canClientViewAccesses')) {
      return true;
    }

    if (user.get('userType') !== 'client' && project.get('canTeamViewAccesses')) {
      return true;
    }

    const types = ['leader', 'responsible', 'manager'];

    if (!project.get('team')) {
      return false;
    }

    return project.get('team')?.find((memberTeam) => {
      return memberTeam?.get('userId') === user.get('userId') && types.includes(memberTeam?.get('type'));
    });
  };
}

class SalaryHistoryIndexOwn {
  execute = (executeParams) => {
    const user = authUserSelector(store.getState());
    if (!executeParams.model) {
      return false;
    }

    return executeParams.model.get('userId') === user.get('userId');
  };
}

class SalaryHistoryCreateOwn {
  execute = (executeParams) => {
    const user = authUserSelector(store.getState());
    if (!executeParams.model) {
      return false;
    }

    return executeParams.model.get('userId') === user.get('userId');
  };
}

class TaskScheduleOwn {
  execute = (executeParams) => {
    if (!executeParams.model) {
      return false;
    }

    const user = authUserSelector(store.getState());
    return executeParams.model.get('creatorId') === user.get('userId');
  };
}

// Map with all available rules
const rules = {
  //Article
  articleUpdateOwn: ArticleUpdateOwn,
  //Comment
  commentUpdateInTask: CommentUpdateInTask,
  isCommentCreator: IsCommentCreator,
  //Client
  clientUserUpdateOwn: ClientUserUpdateOwn,
  clientUserViewOwn: clientUserViewOwn,
  //Event
  eventUpdateOwn: EventUpdateOwn,
  //Project
  projectViewOwn: ProjectViewOwn,
  inProjectLeader: InProjectLeader,
  inProjectTeam: InProjectTeam,
  //Task
  taskResponsible: TaskResponsible,
  taskUpdateOwn: TaskUpdateOwn,
  taskViewOwn: TaskViewOwn,
  taskUpdateLeader: TaskUpdateLeader,
  taskSubscribe: TaskSubscribe,
  //Checklist
  checklistOwn: ChecklistOwn,
  //ToolAccess
  toolAccessViewOwn: ToolAccessViewOwn,
  toolAccessIndexAvailable: ToolAccessIndexAvailable,
  toolAccessCreateOwn: ToolAccessCreateOwn,
  //Time
  taskTimeOwn: TaskTimeOwn,
  timeCreateOwn: TimeCreateOwn,
  timeViewOwn: TimeViewOwn,
  //User
  userUpdateOwn: UserUpdateOwn,
  //SalaryHistory
  salaryHistoryIndexOwn: SalaryHistoryIndexOwn,
  salaryHistoryCreateOwn: SalaryHistoryCreateOwn,
  //TaskSchedule
  taskScheduleOwn: TaskScheduleOwn,
};

export default class RbacRuleFactory {
  static createRule(ruleName) {
    return rules[ruleName] ? new rules[ruleName]() : null;
  }
}
